import queryString from 'query-string'
import { isBrowser } from 'browser-or-node'

export class UrlHashHandler {
    constructor() {
        if (isBrowser) {
            window.addEventListener('hashchange', (e) => {
                e.preventDefault()
                e.stopImmediatePropagation()
                return false
            })
        }
    }

    get dictionary() {
        const hash = isBrowser ? window.location.hash : ''
        return queryString.parse(hash, { decode: false })
    }

    set dictionary(value) {
        if (isBrowser) {
            window.history.replaceState(
                history.state,
                '',
                window.location.pathname +
                    '#' +
                    queryString.stringify(value, {
                        encode: false
                    })
            )
        }
    }

    unsetKey(key) {
        const d = this.dictionary
        if (key in d) {
            delete d[key]
            this.dictionary = d
        }
    }

    setKey(key, value) {
        const d = this.dictionary
        d[key] = value
        this.dictionary = d
    }

    hasKey(key) {
        const d = this.dictionary
        return key in d
    }

    getKey(key: string, asArray: boolean = false) {
        const d = this.dictionary
        const obj = key in d ? d[key] : null
        return asArray && !Array.isArray(obj) ? [obj] : obj
    }
}

const urlHashHandler = new UrlHashHandler()
export { urlHashHandler }
